import React from "react";
import { useLocation } from "react-router";
import { BankFeedsSupportedRutterPlatforms } from "../../components/bankFeeds/constants";
import BankFeedsCommonLayout, {
  LOCAL_STORAGE_ORG_INFO,
  OrgInfo,
} from "../../components/bankFeeds/layout";

const PLATFORM_NAMES: Partial<
  Record<BankFeedsSupportedRutterPlatforms, string>
> = {
  [BankFeedsSupportedRutterPlatforms.INTUIT_BANK_FEEDS]: "Intuit",
  [BankFeedsSupportedRutterPlatforms.PLAID_BANK_FEEDS]: "Plaid",
  [BankFeedsSupportedRutterPlatforms.SAGE_BANK_FEEDS]: "Sage",
  [BankFeedsSupportedRutterPlatforms.YODLEE_BANK_FEEDS]: "Yodlee",
};

const getStoredOrgInfo = (): OrgInfo => {
  const storedOrgInfo = localStorage.getItem(LOCAL_STORAGE_ORG_INFO);
  if (!storedOrgInfo) return {};

  try {
    const parsedOrgInfo = JSON.parse(storedOrgInfo);
    return parsedOrgInfo && typeof parsedOrgInfo === "object"
      ? (parsedOrgInfo as OrgInfo)
      : {};
  } catch {
    return {};
  }
};

const BankFeedsCancelled: React.FC = () => {
  const location = useLocation<{ orgInfo?: OrgInfo }>();
  const orgInfo = location.state?.orgInfo ?? getStoredOrgInfo();
  const platformName = orgInfo.platform
    ? PLATFORM_NAMES[orgInfo.platform]
    : undefined;
  const authorizationName = platformName
    ? `${platformName} Bank Feeds`
    : "Bank Feeds";
  const restartSource = platformName ? ` from ${platformName}` : "";

  return (
    <BankFeedsCommonLayout
      companyLogoUrl={orgInfo.companyLogoUrl}
      name={orgInfo.name}
    >
      <div className="mt-4 text-lg">
        You have cancelled the {authorizationName} authorization process. If you
        would like to try again, please restart the process{restartSource}.
      </div>
    </BankFeedsCommonLayout>
  );
};

export default BankFeedsCancelled;
